export default {
  pageTitle: '新建物料需求',
  selectLine: '选择产线',
  selectLinePlaceholder: '请选择产线',
  requestType: '需求类型',
  typePickup: '领料',
  typeReturn: '退料',
  typeTransfer: '调拨',
  selectMaterial: '选择物料',
  searchPlaceholder: '搜索物料名称 / 编码',
  resetMaterial: '重置物料',
  resetConfirmTitle: '确认重置物料？',
  resetConfirmContent: '重置后将清空当前物料状态，是否继续？',
  resetCancel: '取消',
  resetSuccess: '物料已重置',
  resetFail: '物料重置失败',
  colName: '物料名称',
  colCode: '物料编码',
  colLocation: '库位',
  colStock: '可用库存',
  colQty: '需求数量',
  stockUnit: '个',
  addMaterial: '添加物料',
  summaryTitle: '申请信息',
  summaryLine: '产线',
  summaryType: '需求类型',
  summaryKinds: '物料种类',
  summaryTotalQty: '总需求数量',
  summaryEta: '预计送达时间',
  summaryDelivery: '配送方式',
  etaValue: '3 分钟内',
  deliveryMethod: 'SMT 机器人配送',
  submit: '提交申请',
  submitSuccess: '物料申请提交成功',
  submitFail: '物料申请提交失败',
  submitEmpty: '请至少选择一种物料',
  submitInvalidQty: '请填写有效的需求数量',
  submitNoLine: '请先选择产线',
  lineA: 'SMT 产线 A 区',
  lineB: 'SMT 产线 B 区',
  lineC: 'DIP 产线 C 区',
}
